/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
// @ts-nocheck
// @ts-nocheck
/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';

// Project
import { selectState, actionProps } from 'utils/reduxActions';
import { homeActions } from 'screens/Home/reducer';
import { ReactReduxContext } from 'config/configureStore';
import connectSaga from 'utils/saga';
import saga from './saga';

import { clone, truthty, falsy } from 'utils/functions';
import { Container, withStyles } from '@material-ui/core';
import { workShiftTypesActions } from 'screens/WorkShiftTypes/reducer';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CardHeader from '@material-ui/core/CardHeader';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
// styles
import styles from './styles';
import WorkShiftTypeForm from './components/WorkShiftTypeForm';
import DeleteModal from 'commons/components/DeleteModal';
import MaintainersPaginator from 'commons/components/MaintainersPaginator';

const useStyles = makeStyles(styles);

function WorkShiftTypes(props) {
  const { t } = useTranslation();
  const { objects, formIsOpen, formControls, edit, invalidControls, deleteIsOpen, actions } = props;
  const [workShiftTypeList, setWorkShiftTypeList] = useState([]);
  const [filter, setFilter] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    setWorkShiftTypeList(
      Object.values(objects.workShiftTypes).filter((item) =>
        item.name.toLowerCase().includes(filter.toLowerCase()),
      ),
    );
  }, [objects.workShiftTypes, filter]);

  useEffect(() => {
    actions.getStateFromApi();
  }, [actions]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function toggleForm() {
    actions.toggleForm('formIsOpen');
  }

  function closeForm() {
    actions.toggleForm('deleteIsOpen');
  }

  function toggleDelete() {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  }

  function toggleEdit() {
    handleClose();
    const item = Object.values(objects.workShiftTypes).find(
      (item) => item.id === Number(anchorEl.dataset.id),
    );
    actions.toggleEdit(item);
  }

  function changeControls(event) {
    actions.changeControls(
      { [event.currentTarget.id]: event.target.value },
      { [event.currentTarget.id]: false },
    );
  }

  function submit() {
    if (falsy(formControls.name)) {
      actions.setInvalidControls({
        name: falsy(formControls.name),
      });
    } else if (edit) {
      actions.editWorkShiftType(props.toEditId, formControls);
    } else {
      actions.createWorkShiftType(formControls);
    }
  }

  function submitDelete() {
    actions.deleteWorkShiftType(props.toDeleteId);
  }

  function onFilterChange(event) {
    setFilter(event.target.value);
  }

  const classes = useStyles();

  const getListItem = (
    workShiftType,
    openMenuHandler,
    closeMenuHandler,
    toggleEdit,
    toggleDelete,
  ) => (
    <ListItem key={`workShiftType-${workShiftType.id}`}>
      <ListItemAvatar>
        <Avatar className={classes.blue}>{(workShiftType.name || 'p')[0].toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={workShiftType.name} />
      <ListItemSecondaryAction>
        <IconButton
          data-id={workShiftType.id}
          onClick={handleClick}
          aria-controls={`menu-worshifttype-${workShiftType.id}`}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          id={`menu-worshifttype-${workShiftType.id}`}
          anchorEl={anchorEl}
          keepMounted
          open={truthty(anchorEl)}
          onClose={handleClose}>
          <MenuItem onClick={toggleEdit}>
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            {t('Edit')}
          </MenuItem>
          <MenuItem onClick={toggleDelete}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            {t('Delete')}
          </MenuItem>
        </Menu>
      </ListItemSecondaryAction>
    </ListItem>
  );

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('Work shifts')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardHeader title={t('Filter')} />
            <CardContent>
              <Grid container spacing={3} className={classes.container}>
                <Grid container item xs={4}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label={t('Name')}
                    value={filter}
                    onChange={onFilterChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardContent>
              {truthty(objects.workShiftTypes) ? (
                <MaintainersPaginator
                  classes={classes}
                  list={workShiftTypeList}
                  getListItem={getListItem}
                  openMenuHandler={handleClick}
                  closeMenuHandler={handleClose}
                  toggleEdit={toggleEdit}
                  toggleDelete={toggleDelete}
                />
              ) : (
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                  <Typography variant="h6" component="h2">
                    {t('No work shifts found')}
                  </Typography>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <WorkShiftTypeForm
        isOpen={formIsOpen}
        toggleForm={toggleForm}
        changeControls={changeControls}
        controls={formControls}
        units={objects.units}
        edit={edit}
        submit={submit}
        invalidControls={invalidControls}
      />
      <DeleteModal
        isOpen={deleteIsOpen}
        toggleForm={closeForm}
        submit={submitDelete}
        buttonId="delete-workShiftType"
      />
      <Fab color="primary" aria-label="add" className={classes.fab} onClick={toggleForm}>
        <AddIcon />
      </Fab>
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaWorkShiftTypes', saga });

const withConnect = connect(
  selectState(
    'workShiftTypes.invalidControls',
    'workShiftTypes.formControls',
    'workShiftTypes.deleteIsOpen',
    'workShiftTypes.toDeleteId',
    'workShiftTypes.formIsOpen',
    'workShiftTypes.toEditId',
    'workShiftTypes.edit',
    'app.objects',
  ),
  actionProps(clone(clone.OBJECT, homeActions, workShiftTypesActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(WorkShiftTypes));
